import React, { FC } from 'react';

const Error: FC = () => {
  return <div></div>;
};

export default Error;
